
const WEATER_API_KEY = '1ecc49a3c0c67fa6e0de1b617e17874c';

export const keys = {
  getWeaterApiKey: () => WEATER_API_KEY
};
